
// export const appovalsAccessEnums = [
//     { value: 23871, label: 'visitorsApproval', accessControlId: 20 },
//     { value: 23872, label: 'joinApproval', accessControlId: 21 },
//     { value: 23873, label: 'bankPaymentsApproval', accessControlId: 22 }
// ];
import { BeneficeryIcon, WalletIcon, WithdrawIcon } from "../assets/constant";
export const Appversion = 'v1.2.0';
export const DEFAULT_ROLE_NAME = "QP_CB_User".toLowerCase();
export const accessEnums = {
    VISITORS_APPROVAL: {
        label: 'visitorsApproval',
        accessControlId: 20
    },
    JOIN_APPROVAL: {
        label: 'joinApproval',
        accessControlId: 21
    },
    BANK_PAYMENTS_APPROVAL: {
        value: 23873,
        label: 'bankPaymentsApproval',
        accessControlId: 22
    },

    // Add Expense 

    ADD_EXPENSE: {
        "value": 23788,
        "label": "Add Expense",
        "accessControlId": 17
    },
    TRANSFER_FUND: { value: 23783, label: 'Transfer Fund', accessControlId: 16 },
    VIEW_TRANSACTIONS: {
        value: 23891,
        label: 'View Transactions',
        accessControlId: 24
    }

}


export const walletFeatures = [

    {
        id: "1",
        icon: <WithdrawIcon />,
        title: "Withdraw",
        navigate: "/withdraw"
    }, {

        id: "2",
        icon: <BeneficeryIcon />,
        title: "Beneficiary",
        params: { state: { fromWithDraw: true } },
        navigate: "/beneficiaries"
    },
    // {
    //     id: "3",
    //     icon: <WalletIcon />,
    //     title: "My Account",
    //     navigate: "my-accounts"
    // }
]


// src/utils/transformDashboardData.js

export const transformDashboardData = (data) => {
    return {
        dues: [
            {
                text: "Total Dues",
                count: data?.totalDuesCurrentMonth,
                description: "This Month",
            },
            {
                text: "Recovery",
                count: data?.recoveryCurrentMonth,
                description: "",
            },
            {
                text: "Total Collected",
                count: data?.totalCollectedCurrentMonth,
                description: "This Month",
            },
        ],
        recovery: [
            {
                text: "Recovery",
                count: data?.recoveryCurrentMonth,
                description: "This Month",
            },
            {
                text: "Collected",
                count: data?.collectedCurrentMonthRecovery,
                description: "This Month",
            },
        ],
        total: [
            {
                text: "Total Dues",
                count: data?.duesCurrentMonth + data?.recoveryCurrentMonth,
                description: "This Month",
            },
            {
                text: "Total Pay",
                count:
                    data?.collectedCurrentMonth +
                    data?.collectedCurrentMonthRecovery,
                description: "This Month",
            },
        ],
        approvals: [
            {
                text: "Pending Joinees",
                count: data?.joinCommunityPendingCount,
            },
            {
                text: "Pending Visitors",
                count: data?.visitorPendingCount,
            },
            {
                text: "Pending Banks",
                count: data?.bankPendingCount,
            },
        ],
    }
    
};


 export const roleListForDropdown = [
    {
      value: 1,
      label: "President",
    },
    {
      value: 2,
      label: "Supervisor",
    },
    {
      value: 3,
      label: "Accountant",
    },
    {
      value: 4,
      label: "Others",
    },
  ];


export const scheduleOfChargesData = {

    mainHeading: "All charges are exclusive of applicable service tax unless specified otherwise",
    consumerPaymentsAndWithdrawal: {
        heading: "Consumer Payments & Withdrawal",
        cardData: [
            {
                id: "1",
                label: "Payments & Top-up via local cards & mobile wallets",
                value: "2.10% fee per transaction*"
            },
            {
                id: "2",
                label: "Users withdrawing funds to any bank Account",
                value: "0.2% of the transaction value in Rupees"
            }
        ]
    },
    billSlab: {
        heading: "1 Bill Slab Based Pricing**",
        labelHeading: "Transaction Amount (PKR)",
        valueHeading: "Transaction Fee (PKR)",
        cardData: [
            {
                id: "1",
                label: "Up to 10,000",
                value: "20 /-"
            },
            {
                id: "2",
                label: "10,000+ to 100,000",
                value: "35 /-"
            },
            {
                id: "3",
                label: "100,000+ to 250,000",
                value: "75 /-"
            },
            {
                id: "4",
                label: "250,000+ to 1,000,000",
                value: "150 /-"
            }, {
                id: "5",
                label: "1,000,000+ to 2,500,000",
                value: "300 /-"
            }, {

                id: "6",
                label: "2,500,000+ to 5,000,000",
                value: "400 /-"
            },
            {
                id: "7",
                label: "5,000,000+",
                value: "500 /-"
            }

        ]
    },
    bankAccountSlab: {
        heading: "Bank Account Slab Based Pricing***",
        labelHeading: "Transaction Amount (PKR)",
        valueHeading: "Transaction Fee (PKR)",
        cardData: [
            { id: "1", label: "Up to 10,000", value: "30 /-" },
            { id: "2", label: "10,000+ to 250,000", value: "70 /-" },
            { id: "3", label: "250,000+ to 1,000,000", value: "150 /-" },
            { id: "4", label: "1,000,000+", value: "300 /-" }
        ]
    },
    note: [
        { id: "1", label: "*Transaction via Foreign Bank issued cards are charged at 3.5% of the transaction value in Rupees" },
        { id: "2", label: "**1 Bill pricing is subject to change based on regulatory directives or pricing updates from the bill aggregator" },
        { id: "3", label: "***Bank account payment slabs are subject to change based on pricing changes from high-volume banks." }
    ]

}
